import axios from "axios"
import { PARTNERS_ENDPOINT } from "../../../../../../utility/SourceAPI"

export const fetchPartners = async () => {
    const response = await axios.get(PARTNERS_ENDPOINT)
    return response.data
}

export const createPartner = async (partner) => {
    const response = await axios.post(PARTNERS_ENDPOINT, partner)
    return response.data
}

export const updatePartner = async (partnerId, partner) => {
    const response = await axios.put(PARTNERS_ENDPOINT.concat(`id/${partnerId}`), partner)
    return response.data
}